module.exports = __webpack_public_path__ + "static/img/4.f30a6a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chongqing/4.jpg
// module id = k6t2
// module chunks = 1